import React from 'react';
import './calendar.css';

const Calendar = ({ dates, title, today, navs, prevHandler, nextHandler, dayHandler, close }) => {

    if (!dates || !dates?.length) return false;

    return (
        <div className="calendar">
            <i className="calendar__close" onClick={ close }/>
            <div className="calendar__header">
                {
                    navs
                    ?
                        <div className="calendar__navs">
                            <i
                                className="calendar__nav calendar__nav--prev"
                                onClick={ prevHandler }
                            />
                            <i
                                className="calendar__nav calendar__nav--next"
                                onClick={ nextHandler }
                            />
                        </div>
                    : false
                }
                <div className="calendar__month">{ title }</div>
            </div>
            <div className="calendar__days">
                <div className="calendar__day">Пн</div>
                <div className="calendar__day">Вт</div>
                <div className="calendar__day">Ср</div>
                <div className="calendar__day">Чт</div>
                <div className="calendar__day">Пт</div>
                <div className="calendar__day calendar__day--weekend">Сб</div>
                <div className="calendar__day calendar__day--weekend">Вс</div>
            </div>
            <div className="calendar__items">
                {
                    dates.map((date, index) => {
                        return (
                            <div
                                key={ index }
                                data-count={ date.workout_count > 2 ? date.workout_count : '' }
                                className={
                                    `
                                    calendar__item
                                    ${ today === date.date ? 'calendar__item--today' : '' }
                                    ${ date.workout ? 'calendar__item--active' : '' }
                                    ${ date.inactive ? 'calendar__item--inactive' : '' }
                                    `
                                }
                                onClick={ () => dayHandler(date) }
                            >{ date.day }</div>
                        )
                    })
                }
            </div>
            <div className="calendar__record-wrapper">
                <span className="calendar__record" onClick={ () => dayHandler({ date: today }) }>Списать сегодня</span>
            </div>
        </div>
    );
};

export default Calendar;